<div class="flex flex-col justify-center items-center w-full h-full py-8 px-4">
    <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">
        <!-- Logo -->
        <div class="w-48">
            <img src="assets/images/logo/curelink.png">
        </div>

        <!-- Log in form -->
        <form *ngIf="stage" class="mt-8" [formGroup]="logInForm" #signInNgForm="ngForm">

            <!-- Phone field -->
            <mat-form-field *ngIf="stage==='phone'" class="w-full">
                <mat-label>Phone Number</mat-label>
                <span matTextPrefix>+91&nbsp;</span>
                <input id="phone" matInput type="text" pattern="[0-9]*" [formControlName]="'phone'" >
                <mat-error *ngIf="logInForm.get('phone').hasError('required')">
                    Phone number is required
                </mat-error>
                <mat-error *ngIf="logInForm.get('phone').hasError('maxLength') || logInForm.get('phone').hasError('minLength')">
                    Please enter a valid phone number
                </mat-error>
            </mat-form-field>

            <!-- Password field -->
            <mat-form-field *ngIf="stage==='otp'" class="w-full">
                <mat-label>OTP</mat-label>
                <input matInput type="text" pattern="[0-9]*" [formControlName]="'otp'" #otpInput>
                <mat-error>
                    OTP is required
                </mat-error>
            </mat-form-field>

            <!-- Submit button -->
            <button class="fuse-mat-button-large w-full mt-6" mat-flat-button [color]="'primary'"
                [disabled]="logInForm.disabled" (click)="logIn()">
                <span *ngIf="!logInForm.disabled">
                    {{stage==='phone'?'Send OTP':'Log in'}}
                </span>
                <mat-progress-spinner *ngIf="logInForm.disabled" [diameter]="24"
                    [mode]="'indeterminate'"></mat-progress-spinner>
            </button>
        </form>
    </div>
</div>
